export const appRoutes = {
  home: '/',
  login: '/login',
  logout: '/logout',
  library: '/library',
  noConnection: '/no-connection',
  accessDenied: '/access-denied',
  emailVerified: '/email-verified',
  emailVerification: '/verify-email',
  agreementEula: '/agreements/eula',
  agreementBaa: '/agreements/baa',
  cortex: '/cortex',
  tags: '/tags',
  instructions: '/instructions',
  archive: '/archive',
  settings: '/settings',
  settingsPersonalization: '/settings/personalization',
  settingsBilling: '/settings/billing',
  // TEMPORARY, dev environment only — see features/component-library.
  componentLibrary: '/component-library',
} as const;

export const apiRoutes = {
  firebaseAuth: `/auth`,
  acceptAgreements: `/auth/agreements/accept`,
  accessCheck: `/auth/access`,
  billingPlans: `/billing/plans`,
  billingCheckoutSession: `/billing/checkout-session`,
  billingTopUpSession: `/billing/top-up-session`,
  billingPortalSession: `/billing/portal-session`,
  billingCancel: `/billing/cancel`,
  billingUndoCancel: `/billing/undo-cancel`,
  billingEndTrial: `/billing/end-trial`,
};
